module.exports = __webpack_public_path__ + "static/media/dashenghover.8477875e.png";